var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _rect3, _path10, _path11, _rect4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioHoldings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.549,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.476,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8076,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.066 100.347C167.066 137.155 136.962 167.009 99.8076 167.009C62.6536 167.009 32.5493 137.155 32.5493 100.347C32.5493 63.539 62.6536 33.6853 99.8076 33.6853C136.962 33.6853 167.066 63.539 167.066 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11489,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.793,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.76,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0478,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.936,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.975 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01221 117.65C7.0667 117.65 7.92153 116.795 7.92153 115.741C7.92153 114.686 7.0667 113.831 6.01221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0317 22.4227C75.0862 22.4227 75.9411 21.5679 75.9411 20.5134C75.9411 19.4589 75.0862 18.6041 74.0317 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 15.7399C119.279 15.7399 118.424 16.5947 118.424 17.6492C118.424 18.7037 119.279 19.5585 120.333 19.5585",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83057 166.934H15.7972M25.8211 155.836V157.388M37.5157 166.934H39.0671M25.8211 176.481V178.271M25.8211 180.658V186.982M21.4058 166.934C24.3892 166.934 25.9405 162.638 25.9405 162.638C25.9405 162.638 26.4178 166.934 30.2365 166.934C28.5181 166.934 26.0598 168.486 25.8211 171.588C25.8211 171.588 25.5432 169.048 24.6278 168.128C23.8635 167.359 21.4058 166.934 21.4058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0597L172.242 30.0597M162.099 45.8116L162.218 39.6063M150.524 30.0597L148.972 30.0597M162.099 20.7518L162.099 8.57985M166.634 30.0597C163.65 30.0597 162.099 34.3557 162.099 34.3557C162.099 34.3557 161.622 30.0597 157.803 30.0597C159.521 30.0597 161.98 28.5084 162.218 25.4057C162.218 25.4057 162.496 27.9459 163.412 28.8664C164.176 29.635 166.634 30.0597 166.634 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 71.1826,
    width: 96,
    height: 64.1111,
    rx: 9,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 71.1826,
    width: 96,
    height: 36.1111,
    rx: 9,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6665 67.0714V62.1826C83.6665 58.8688 86.3528 56.1826 89.6665 56.1826H111.111C114.425 56.1826 117.111 58.8688 117.111 62.1826V66.4775",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1113 67.0713V64.6269C89.1113 62.97 90.4545 61.6269 92.1113 61.6269H108.667C110.324 61.6269 111.667 62.97 111.667 64.6269V66.7744",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5552,
    y: 98.4049,
    width: 12.7778,
    height: 17.4444,
    rx: 6.38889,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.908 101C146.763 101 132.608 105.289 130.892 107.005C129.176 108.721 130.463 126.479 130.463 130.597C130.463 134.715 132.751 138.89 133.895 140.462C137.326 143.608 144.189 149.899 146.334 151.615C148.479 153.331 151.052 152.902 152.339 151.615C153.626 150.328 159.422 146.876 162.634 142.607C166.06 138.054 168.353 132.17 168.639 129.31C168.925 126.45 169.068 108.721 167.781 107.005C166.494 105.289 151.052 101 148.908 101Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.36 126.455C154.936 125.713 154.299 125.069 153.465 124.538C152.682 124.04 151.499 123.545 149.847 123.024C148.097 122.472 147.289 121.979 146.921 121.663C146.488 121.292 146.278 120.762 146.278 120.045C146.278 119.292 146.518 118.718 147.012 118.288C147.523 117.842 148.256 117.625 149.251 117.625C150.2 117.625 150.915 117.893 151.438 118.443C151.994 119.029 152.264 119.828 152.264 120.887C152.264 121.403 152.715 121.822 153.272 121.822H154.846C155.403 121.822 155.855 121.403 155.855 120.887C155.855 119.041 155.346 117.541 154.344 116.427C153.646 115.652 152.754 115.101 151.68 114.78C151.262 114.655 150.974 114.3 150.974 113.891V112.936C150.974 112.419 150.522 112 149.965 112H148.616C148.059 112 147.608 112.419 147.608 112.936V113.866C147.608 114.28 147.312 114.642 146.884 114.761C145.866 115.042 145.001 115.516 144.3 116.175C143.23 117.182 142.687 118.495 142.687 120.077C142.687 121.584 143.183 122.841 144.162 123.813C145.095 124.74 146.609 125.5 148.762 126.126C150.576 126.709 151.386 127.221 151.747 127.549C152.183 127.946 152.396 128.455 152.396 129.108C152.396 129.833 152.133 130.379 151.568 130.824C150.962 131.302 150.173 131.534 149.158 131.534C147.983 131.534 147.114 131.265 146.502 130.713C145.897 130.168 145.604 129.406 145.604 128.384C145.604 127.867 145.152 127.448 144.595 127.448H143.008C142.451 127.448 142 127.867 142 128.384C142 130.239 142.585 131.74 143.739 132.845C144.541 133.612 145.568 134.144 146.805 134.436C147.252 134.542 147.568 134.912 147.568 135.341V136.064C147.568 136.581 148.02 137 148.576 137H149.913C150.47 137 150.921 136.581 150.921 136.064V135.297C150.921 134.875 151.229 134.511 151.668 134.397C152.727 134.119 153.622 133.651 154.342 132.996C155.442 131.995 156 130.679 156 129.083C156 128.082 155.785 127.197 155.36 126.455Z",
    fill: "#194590"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    transform: "translate(85 90)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 120.843C97.6677 120.843 94.0666 119.349 91.3565 116.643C88.6464 113.937 87.1572 110.332 87.1572 106.5C87.1572 102.668 88.6505 99.0668 91.3565 96.3566C94.0625 93.6465 97.6677 92.1574 101.5 92.1574C105.332 92.1574 108.933 93.6506 111.643 96.3566C114.353 99.0626 115.842 102.668 115.842 106.5C115.842 110.332 114.349 113.933 111.643 116.643C108.937 119.353 105.332 120.843 101.5 120.843ZM101.5 92.3224C97.7131 92.3224 94.1532 93.7991 91.4761 96.4763C88.799 99.1534 87.3222 102.713 87.3222 106.5C87.3222 110.287 88.799 113.847 91.4761 116.524C94.1532 119.201 97.7131 120.678 101.5 120.678C105.287 120.678 108.846 119.201 111.524 116.524C114.201 113.847 115.677 110.287 115.677 106.5C115.677 102.713 114.201 99.1534 111.524 96.4763C108.846 93.7991 105.287 92.3224 101.5 92.3224Z",
    fill: "#787E8C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 117.068C98.6782 117.068 96.0258 115.971 94.0293 113.975C92.0328 111.978 90.9355 109.326 90.9355 106.504C90.9355 103.683 92.0328 101.03 94.0293 99.0338C96.0258 97.0373 98.6782 95.94 101.5 95.94C104.321 95.94 106.974 97.0373 108.97 99.0338C110.967 101.03 112.064 103.683 112.064 106.504C112.064 109.326 110.967 111.978 108.97 113.975C106.974 115.971 104.321 117.068 101.5 117.068ZM101.5 96.0968C98.7194 96.0968 96.1083 97.1775 94.1448 99.1452C92.1813 101.109 91.0964 103.72 91.0964 106.5C91.0964 109.28 92.1772 111.891 94.1448 113.855C96.1083 115.818 98.7194 116.903 101.5 116.903C104.28 116.903 106.891 115.823 108.855 113.855C110.818 111.891 111.903 109.28 111.903 106.5C111.903 103.72 110.822 101.109 108.855 99.1452C106.891 97.1817 104.28 96.0968 101.5 96.0968Z",
    fill: "#787E8C",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.499 110.596C99.2389 110.596 97.4033 108.761 97.4033 106.5C97.4033 104.24 99.2389 102.404 101.499 102.404C103.76 102.404 105.596 104.24 105.596 106.5C105.596 108.761 103.76 110.596 101.499 110.596ZM101.499 102.569C99.3338 102.569 97.5683 104.334 97.5683 106.5C97.5683 108.666 99.3338 110.431 101.499 110.431C103.665 110.431 105.431 108.666 105.431 106.5C105.431 104.334 103.665 102.569 101.499 102.569Z",
    fill: "#787E8C",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M107.836 109.07C111.522 109.07 114.51 106.082 114.51 102.396C114.51 98.7096 111.522 95.7214 107.836 95.7214C104.15 95.7214 101.162 98.7096 101.162 102.396C101.162 106.082 104.15 109.07 107.836 109.07Z",
    fill: "#787E8C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 120.843C97.6677 120.843 94.0666 119.349 91.3565 116.643C88.6464 113.937 87.1572 110.332 87.1572 106.5C87.1572 102.668 88.6505 99.0668 91.3565 96.3566C94.0625 93.6465 97.6677 92.1574 101.5 92.1574C105.332 92.1574 108.933 93.6506 111.643 96.3566C114.353 99.0626 115.842 102.668 115.842 106.5C115.842 110.332 114.349 113.933 111.643 116.643C108.937 119.353 105.332 120.843 101.5 120.843ZM101.5 92.3224C97.7131 92.3224 94.1532 93.7991 91.4761 96.4763C88.799 99.1534 87.3222 102.713 87.3222 106.5C87.3222 110.287 88.799 113.847 91.4761 116.524C94.1532 119.201 97.7131 120.678 101.5 120.678C105.287 120.678 108.846 119.201 111.524 116.524C114.201 113.847 115.677 110.287 115.677 106.5C115.677 102.713 114.201 99.1534 111.524 96.4763C108.846 93.7991 105.287 92.3224 101.5 92.3224Z",
    fill: "#787E8C",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.7682 107.333C88.9102 107.333 88.0811 107.449 87.2891 107.663C87.3551 108.459 87.4829 109.235 87.6727 109.99C88.3327 109.784 89.0381 109.672 89.7682 109.672C93.6539 109.672 96.8054 112.824 96.8054 116.709C96.8054 117.782 96.5662 118.801 96.1331 119.712C96.8549 120.005 97.6098 120.245 98.3853 120.418C98.8762 119.279 99.1484 118.029 99.1484 116.714C99.1443 111.533 94.9451 107.333 89.7682 107.333Z",
    fill: "#787E8C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.948 96.794C110.954 95.7256 109.803 94.8099 108.524 94.088C109.308 94.8882 109.795 95.9814 109.795 97.19C109.795 99.6361 107.815 101.616 105.369 101.616C102.923 101.616 100.943 99.6361 100.943 97.19C100.943 94.7521 102.91 92.7762 105.344 92.7639C104.123 92.4215 102.832 92.24 101.504 92.24C101.339 92.24 101.174 92.2441 101.009 92.2482C99.6434 93.4569 98.7812 95.2224 98.7812 97.19C98.7812 100.832 101.731 103.782 105.373 103.782C109.015 103.782 111.965 100.832 111.965 97.19C111.961 97.058 111.952 96.926 111.948 96.794Z",
    fill: "#787E8C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9005 103.699C89.5787 103.699 89.2776 103.505 89.1497 103.192C89.0672 102.99 89.0713 102.771 89.158 102.573C89.2446 102.375 89.4013 102.222 89.5993 102.14C90.0118 101.975 90.4862 102.177 90.6512 102.589C90.7337 102.792 90.7296 103.01 90.643 103.208C90.5563 103.406 90.3996 103.559 90.2016 103.641C90.1026 103.678 89.9995 103.699 89.9005 103.699ZM89.8963 102.247C89.818 102.247 89.7355 102.264 89.6571 102.292C89.4962 102.358 89.3725 102.478 89.3065 102.639C89.2405 102.796 89.2363 102.973 89.3023 103.13C89.4343 103.46 89.8097 103.621 90.1397 103.489C90.3006 103.423 90.4243 103.303 90.4903 103.142C90.5563 102.985 90.5605 102.808 90.4945 102.651C90.3955 102.4 90.1521 102.247 89.8963 102.247Z",
    fill: "#787E8C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.104 110.938C112.782 110.938 112.481 110.745 112.353 110.431C112.27 110.229 112.274 110.01 112.361 109.812C112.448 109.614 112.604 109.462 112.802 109.379C113.215 109.214 113.689 109.412 113.854 109.829C114.019 110.241 113.821 110.716 113.405 110.881C113.306 110.918 113.203 110.938 113.104 110.938ZM113.099 109.486C113.021 109.486 112.939 109.503 112.86 109.532C112.699 109.598 112.576 109.717 112.51 109.878C112.444 110.035 112.439 110.212 112.505 110.369C112.637 110.699 113.013 110.86 113.343 110.728C113.673 110.596 113.834 110.221 113.702 109.891C113.599 109.639 113.355 109.486 113.099 109.486Z",
    fill: "#787E8C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.802 102.078C96.7649 102.078 96.7277 102.078 96.6865 102.074C96.3977 102.045 96.142 101.905 95.9605 101.678C95.779 101.451 95.6965 101.17 95.7254 100.886C95.7542 100.601 95.8945 100.341 96.1214 100.16C96.5834 99.7844 97.2681 99.8545 97.6435 100.317C97.825 100.539 97.9075 100.824 97.8786 101.109C97.8497 101.393 97.7095 101.653 97.4826 101.835C97.2887 101.991 97.0495 102.078 96.802 102.078ZM96.7979 100.077C96.5875 100.077 96.3854 100.147 96.2204 100.284C96.0306 100.436 95.911 100.659 95.8862 100.902C95.8615 101.146 95.9316 101.385 96.0842 101.575C96.2369 101.764 96.4596 101.884 96.703 101.909C96.9464 101.934 97.1856 101.863 97.3754 101.711C97.5651 101.558 97.6847 101.335 97.7095 101.092C97.7342 100.849 97.6641 100.609 97.5115 100.42C97.3589 100.23 97.1361 100.11 96.8927 100.086C96.8639 100.081 96.8309 100.077 96.7979 100.077Z",
    fill: "#787E8C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.914 113.306C105.601 113.306 105.287 113.17 105.073 112.906C104.891 112.683 104.809 112.399 104.838 112.114C104.867 111.829 105.007 111.569 105.234 111.388C105.696 111.013 106.38 111.083 106.756 111.545C107.131 112.007 107.061 112.691 106.599 113.067C106.393 113.228 106.154 113.306 105.914 113.306ZM105.91 111.31C105.708 111.31 105.502 111.376 105.333 111.516C104.941 111.833 104.879 112.411 105.197 112.807C105.514 113.203 106.092 113.261 106.488 112.943C106.88 112.625 106.941 112.048 106.624 111.652C106.442 111.425 106.178 111.31 105.91 111.31Z",
    fill: "#787E8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioHoldings);
export default __webpack_public_path__ + "static/media/portfolio-holdings.fc80d311c5cb792cc6f3692f35603830.svg";
export { ForwardRef as ReactComponent };